import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/loader';

import {
  fetchMe,
  enableAddressbookWhitelist,
  disableAddressbookWhitelist,
} from '../../actions';

class WhitelistModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabledSuccess: false,
      enabledSuccess: false,
      use2fa: false,
      useYubi: false,
      otp: '',
      pristine: true,
      manualYubiKey: false,
      accepted: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.enableWhitelist = this.enableWhitelist.bind(this);
    this.disableWhitelist = this.disableWhitelist.bind(this);
    this.toggleYubikeyListener = this.toggleYubikeyListener.bind(this);
    this.captureYubiKey = this.captureYubiKey.bind(this);
    this.toggleYubiKeyManual = this.toggleYubiKeyManual.bind(this);
  }

  componentDidMount() {
    const { accepted } = this.state;
    const { user, resetCode } = this.props;
    let yubiEnabled;

    if (user.security) {
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }
  }

  componentWillUnmount() {
    this.toggleYubikeyListener('DISABLE');
  }

  toggleYubikeyListener(type) {
    if (type === 'ENABLE') {
      document.addEventListener('keypress', this.captureYubiKey, false);
    }
    if (type === 'DISABLE') {
      document.removeEventListener('keypress', this.captureYubiKey, false);
    }
  }

  toggleYubiKeyManual() {
    const { manualYubiKey } = this.state;
    if (!manualYubiKey) {
      this.toggleYubikeyListener('DISABLE');
    } else {
      this.toggleYubikeyListener('ENABLE');
    }
    this.setState({manualYubiKey: !manualYubiKey, otp: ''})
  }

  captureYubiKey(e) {
    const { user, whitelistEnabled } = this.props;
    const { otp } = this.state;

    let yubiEnabled;

    if (user.security) {
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }

    if (e.which === 13 || e.key === 'Enter') {
      if (whitelistEnabled) {
        this.disableWhitelist(e);
        return;
      }
      this.enableWhitelist(e);
      return;
    }
    let useYubikey = '' + e.key;
    if (otp) {
      useYubikey = otp + e.key;
    }
    this.setState({otp: useYubikey});
  }

  startTfa() {
    const { user } = this.props;
    let yubiEnabled;
    if (user.security) {
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }

    this.setState({accepted: true});
    if (yubiEnabled) {
      this.toggleYubikeyListener('ENABLE');
    }
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value, pristine: false });
  }

  enableWhitelist(e) {
    e.preventDefault();
    const { otp } = this.state;
    const { dispatch } = this.props;
    const data = {
      otp
    }
    this.setState({pristine: true})
    dispatch(enableAddressbookWhitelist(data))
      .then((res) => {
        if (res.type === 'ENABLE_ADDRESSBOOK_WHITELIST_SUCCESS') {
          this.toggleYubikeyListener('DISABLE');
          this.setState({enabledSuccess: true});
          dispatch(fetchMe());
        }
      });
  }

  disableWhitelist(e) {
    e.preventDefault();
    const { otp } = this.state;
    const { dispatch } = this.props;
    const data = {
      otp
    }
    this.setState({pristine: true})
    dispatch(disableAddressbookWhitelist(data))
      .then((res) => {
        if (res.type === 'DISABLE_ADDRESSBOOK_WHITELIST_SUCCESS') {
          this.toggleYubikeyListener('DISABLE');
          this.setState({disabledSuccess: true});
          dispatch(fetchMe());
        }
      });
  }

  render() {
    const { otp, enabledSuccess, disabledSuccess, pristine, manualYubiKey, accepted } = this.state;
    const { errors, success, user, whitelistEnabled } = this.props;

    let otpEnabled;
    let yubiEnabled;

    if (user.security) {
      const otpHandle = user.security.find(e => e.typeHandle === 'OTP');
      if (otpHandle && otpHandle.statusHandle === 'ACTIVATED') {
        otpEnabled = true;
      }
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }

    const complete = !pristine && otp;

    if (enabledSuccess || disabledSuccess) {
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="modal-title">
            Address Book Whitelist
          </div>
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">
                {enabledSuccess ? (
                  'Whitelist Enabled Successfully'
                ) : null}
                {disabledSuccess ? (
                  'Whitelist Disabled Successfully'
                ) : null}
              </div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              {enabledSuccess ? (
                <>
                  <p>Your address book whitelist has been enabled successfully.</p>
                  <p>There will be a 1 hour grace period before your whitelist is fully activated. Until then you can add as many addresses to your address book as needed without restriction, but will only be able to withdraw to saved addresses.</p>
                  <p>After this grace period is up, you must wait an additional 48 hours before withdrawing to any newly added addresses.</p>
                </>
              ) : null}
              {disabledSuccess ? (
                <>
                  <p>Your address book whitelist has been disabled successfully.</p>
                  <p>For security purposes your whitelist will remain active for 48 hours.</p>
                  <p>After this grace period is up you will be able to withdraw to addresses that are not saved in your address book.</p>
                </>
              ) : null}
            </div>
            <div className="cell small-12 medium-12 large-12 modal-actions">
              <button className="button" type="button" onClick={() => this.props.toggleModal(null)}>
                <span>
                  Close
                </span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (!accepted) {
      if (whitelistEnabled) {
        return (
          <div className="cell small-12 medium-12 large-12">
            <div className="modal-title">
              Address Book Whitelist
            </div>
            <div className="grid-x">
              <div className="cell small-12 medium-12 large-12">
                <div className="modal-heading">Disable Whitelist</div>
                <div className="cell small-12 medium-12 large-12">
                  <p>For security purposes your whitelist will remain active for 48 hours after disabling it.</p>
                  <p>After this grace period is up you will be able to withdraw to addresses that are not saved in your address book.</p>
                </div>
              </div>
              <div className="cell small-12 medium-12 large-12 modal-actions">
                <button className="button" type="submit" onClick={() => this.props.toggleModal(null)}>
                  <span>
                    Cancel
                  </span>
                </button>
                <button className="vlt-button" type="button" onClick={() => this.startTfa()}>
                  <span>
                    Continue
                  </span>
                </button>
              </div>
            </div>
          </div>
        );
      }
      if (!whitelistEnabled) {
        return (
          <div className="cell small-12 medium-12 large-12">
            <div className="modal-title">
              Address Book Whitelist
            </div>
            <div className="grid-x">
              <div className="cell small-12 medium-12 large-12">
                <div className="modal-heading">Enable Whitelist</div>
                <div className="cell small-12 medium-12 large-12">
                  <p>There will be a 1 hour grace period before your whitelist is fully activated. Until then you can add as many addresses to your address book as needed without restriction, but will only be able to withdraw to saved addresses.</p>
                  <p>After this grace period is up, you must wait an additional 48 hours before withdrawing to any newly added addresses.</p>
                </div>
              </div>
              <div className="cell small-12 medium-12 large-12 modal-actions">
                <button className="button" type="submit" onClick={() => this.props.toggleModal(null)}>
                  <span>
                    Cancel
                  </span>
                </button>
                <button className="vlt-button" type="button" onClick={() => this.startTfa()}>
                  <span>
                    Continue
                  </span>
                </button>
              </div>
            </div>
          </div>
        );
      }
    }

    if (accepted) {
      if (whitelistEnabled) {
        if (yubiEnabled) {
          return (
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-title">
                Address Book Whitelist
              </div>
              <div className="grid-x">
                <div className="cell small-12 medium-12 large-12">
                  <div className="modal-heading">Disable Whitelist</div>
                  <div className="modal-subheading">
                    Enter your authenticator code below to disable your address book whitelist
                  </div>
                  <div className="cell small-12 medium-12 large-12">
                    <form onSubmit={this.disableWhitelist} id="form1" autoComplete="off">
                      <div>
                        <img alt="YubiKeys" src={ process.env.REACT_APP_CDN + '/assets/images/yubikeys.png'} style={{maxWidth: '80%', marginBottom: '20px'}}/>
                      </div>
                      {manualYubiKey ? (
                        <div>
                          <input id="otp" className="modal-input" type="password" name="otp" placeholder="Enter YubiKey" value={otp} autoComplete="off" onChange={this.handleChange} autoFocus />
                        </div>
                      ) : null}
                    </form>
                  </div>
                </div>
                {manualYubiKey ? (
                  null
                ) : (
                  <div className="cell small-12 medium-12 large-12 modal-actions">
                    <button className="button" type="submit" onClick={this.toggleYubiKeyManual}>
                      <span>
                        Enter Manually
                      </span>
                    </button>
                  </div>
                )}
                <div className="cell small-12 medium-12 large-12 modal-actions">
                  <button className="button" type="submit" onClick={() => this.props.toggleModal(null)}>
                    <span>
                      Cancel
                    </span>
                  </button>
                  <button className="vlt-button" type="submit" form="form1" disabled={!complete}>
                    <span>
                      Confirm
                    </span>
                  </button>
                </div>
              </div>
            </div>
          );
        }
        if (otpEnabled) {
          return (
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-title">
                Address Book Whitelist
              </div>
              <div className="grid-x">
                <div className="cell small-12 medium-12 large-12">
                  <div className="modal-heading">Disable Whitelist</div>
                  <div className="modal-subheading">
                    Enter your authenticator code below to disable your address book whitelist
                  </div>
                  <div className="cell small-12 medium-12 large-12">
                    <form onSubmit={this.disableWhitelist} id="form2" autoComplete="off">
                      <input id="otp" className="modal-input" type="text" name="otp" placeholder="Enter Auth Token" value={otp} autoComplete="off" onChange={this.handleChange} autoFocus />
                    </form>
                  </div>
                </div>
                <div className="cell small-12 medium-12 large-12 modal-actions">
                  <button className="button" type="submit" onClick={() => this.props.toggleModal(null)}>
                    <span>
                      Cancel
                    </span>
                  </button>
                  <button className="vlt-button" type="submit" form="form2" disabled={!complete}>
                    <span>
                      Confirm
                    </span>
                  </button>
                </div>
              </div>
            </div>
          );
        }
      }

      if (!whitelistEnabled) {
        if (yubiEnabled) {
          return (
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-title">
                Address Book Whitelist
              </div>
              <div className="grid-x">
                <div className="cell small-12 medium-12 large-12">
                  <div className="modal-heading">Enable Whitelist</div>
                  <div className="modal-subheading">
                    Enter your authenticator code below to enable your address book whitelist
                  </div>
                  <div className="cell small-12 medium-12 large-12">
                    <form onSubmit={this.enableWhitelist} id="form1" autoComplete="off">
                      <div>
                        <img alt="YubiKeys" src={ process.env.REACT_APP_CDN + '/assets/images/yubikeys.png'} style={{maxWidth: '80%', marginBottom: '20px'}}/>
                      </div>
                      {manualYubiKey ? (
                        <div>
                          <input id="otp" className="modal-input" type="password" name="otp" placeholder="Enter YubiKey" value={otp} autoComplete="off" onChange={this.handleChange} autoFocus />
                        </div>
                      ) : null}
                    </form>
                  </div>
                </div>
                {manualYubiKey ? (
                  null
                ) : (
                  <div className="cell small-12 medium-12 large-12 modal-actions">
                    <button className="button" type="submit" onClick={this.toggleYubiKeyManual}>
                      <span>
                        Enter Manually
                      </span>
                    </button>
                  </div>
                )}
                <div className="cell small-12 medium-12 large-12 modal-actions">
                  <button className="button" type="submit" onClick={() => this.props.toggleModal(null)}>
                    <span>
                      Cancel
                    </span>
                  </button>
                  <button className="vlt-button" type="submit" form="form1" disabled={!complete}>
                    <span>
                      Confirm
                    </span>
                  </button>
                </div>
              </div>
            </div>
          );
        }
        if (otpEnabled) {
          return (
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-title">
                Address Book Whitelist
              </div>
              <div className="grid-x">
                <div className="cell small-12 medium-12 large-12">
                  <div className="modal-heading">Enable Whitelist</div>
                  <div className="modal-subheading">
                    Enter your authenticator code below to enable your address book whitelist
                  </div>
                  <div className="cell small-12 medium-12 large-12">
                    <form onSubmit={this.enableWhitelist} id="form1" autoComplete="off">
                      <input id="otp" className="modal-input" type="text" name="otp" placeholder="Enter Auth Token" value={otp} autoComplete="off" onChange={this.handleChange} autoFocus />
                    </form>
                  </div>
                </div>
                <div className="cell small-12 medium-12 large-12 modal-actions">
                  <button className="button" type="submit" onClick={() => this.props.toggleModal(null)}>
                    <span>
                      Cancel
                    </span>
                  </button>
                  <button className="vlt-button" type="submit" form="form1" disabled={!complete}>
                    <span>
                      Confirm
                    </span>
                  </button>
                </div>
              </div>
            </div>
          );
        }
      }
    }

    if (!otpEnabled && !yubiEnabled) {
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="modal-title">
            Address Book Whitelist
          </div>
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">2FA required</div>
              <div className="cell small-12 medium-12 large-12">
                <p>2FA is required before you can enable your address book whitelist.</p>
                <p>You can enable 2FA in your settings, under the security section.</p>
              </div>
            </div>
            <div className="cell small-12 medium-12 large-12 modal-actions">
              <button className="button" type="submit" onClick={() => this.props.toggleModal(null)}>
                <span>
                  Cancel
                </span>
              </button>
              <a className="button" href="/settings">
                <span>
                  View Settings
                </span>
              </a>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="cell small-12 medium-12 large-12">
        <div className="modal-title">
          Address Book Whitelist
        </div>
        <div className="grid-x" style={{marginTop: '40px', marginBottom: '40px'}}>
          <div className="center-loader">
            <Loader logo />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.addressbook.errors,
  success: state.addressbook.success,
  addressbook: state.addressbook.addressbook,
  assets: state.assets.assets,
});

export default connect(mapStateToProps)(WhitelistModal);
